import { Button } from 'antd';
import React, { Fragment, useState } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Call from '../../../hocs/call';
import ReduxCodelistDetailModal from '../../../redux-components/redux-codelist-detail-modal';
import { showCodelistDetail } from '../../../redux-components/redux-codelist-detail-modal/actions';
import { MODAL_WIDTH_LG } from '../../../styles/constants';
import { reuseAction } from '../../../utils/reduxReuse';
import ArtefactList from '../../artefact-list';
import EnhancedModal from '../../enhanced-modal';
import { readELCodelists, setELDimensionsColumnsValues } from '../actions';
import { EL_CODELIST_DETAIL_PREFIX } from '../reducer';
import ELDimensionsStepTable from "./Table";

const mapStateToProps = state => ({
  nodeId: state.app.endpointId,
  nodes: state.config.nodes,
  structureColumns: state.scenes.easyLoading.structureColumns,
  codelists: state.scenes.easyLoading.structureCodelists,
  codelistDetail: state.scenes.easyLoading.codelistDetail,
  astTerritorialCodelist: state.scenes.easyLoading.astTerritorialCodelist,
}); 

const mapDispatchToProps = dispatch => ({
  onChange: (columnId, role, association) => 
    dispatch(setELDimensionsColumnsValues(columnId, role, association)),  
  onCodelistsFetch: () => dispatch(readELCodelists()),
  onCodelistShow: (codelistTriplet, defaultItemsViewMode) =>
    dispatch(reuseAction(showCodelistDetail(codelistTriplet, defaultItemsViewMode),  EL_CODELIST_DETAIL_PREFIX)),
});


const ELDimensionsStep = ({
                          t,
                          nodeId,
                          nodes,
                          structureColumns,
                          codelists,
                          codelistDetail,
                          astTerritorialCodelist,
                          onChange,
                          onCodelistsFetch,
                          onCodelistShow
                          }) => {

  const [rowToAssociateCodelist, setRowToAssociateCodelist] = useState(null);
  const connectedNode = nodes.find(node => node.general.id === nodeId);
  const defaultItemsViewMode = connectedNode
    ? connectedNode.general.defaultItemsViewMode
    : null;

  const handleCodelistSelect = (codelist) => {
    onChange(rowToAssociateCodelist.id, rowToAssociateCodelist.dimensionDefinition.role, codelist);
    setRowToAssociateCodelist(null)
  }
                                                      
  return (
    <Call cb={onCodelistsFetch} disabled={codelists !== null}>  
      <Fragment>
        <ELDimensionsStepTable
            structureColumns={structureColumns}
            setRowToAssociateCodelist={setRowToAssociateCodelist}
            astTerritorialCodelist={astTerritorialCodelist}
            onChange={onChange}
        />
        <EnhancedModal
          visible={rowToAssociateCodelist !== null}
          onCancel={() => setRowToAssociateCodelist(null)}
          title={t('components.easyLoading.dimensions.table.modals.codelists.title')}
          width={MODAL_WIDTH_LG}
          footer={<Button onClick={() => setRowToAssociateCodelist(null)}>{t('commons.buttons.close.title')}</Button>}
        >         
          <ArtefactList
            artefacts={codelists}
            onRowClick={codelist => handleCodelistSelect(codelist)}
            onDetailShow={triplet => onCodelistShow(triplet, defaultItemsViewMode)}
            getIsDisabledRow={({isFinal}) => !isFinal}
          />        
        </EnhancedModal>
        <ReduxCodelistDetailModal
          instancePrefix={EL_CODELIST_DETAIL_PREFIX}
          instanceState={codelistDetail}
        />
      </Fragment>
    </Call>  
  )};                      
  
  export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
  )(ELDimensionsStep);


// WEBPACK FOOTER //
// ./src/components/easy-loading/dimensions-step/index.jsx